import { useEffect } from 'react'

import { useToast } from '@redriverpress/system'

import { useStudentOnboardingContext } from '../../context/onboardingStudentContext'

export default function FlashMessage() {
  const { addToast } = useToast()

  const [{ flashMessage }] = useStudentOnboardingContext()

  useEffect(() => {
    if (flashMessage) {
      addToast(flashMessage)
    }
  }, [flashMessage])

  return null
}
